export default __webpack_public_path__ + "static/media/Flag_of_Belgium.3d2245c5.svg";